// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file satelite.proto (package sextante.satelite.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file satelite.proto.
 */
export const file_satelite: GenFile = /*@__PURE__*/
  fileDesc("Cg5zYXRlbGl0ZS5wcm90bxIUc2V4dGFudGUuc2F0ZWxpdGUudjEiPAoURXNjZW5hSW5kaWNlVGlsZUl0ZW0SEQoJaW5kaWNlX2lkGAEgASgJEhEKCWltYWdlX3VyaRgCIAEoCSL3AgoKRXNjZW5hSXRlbRIKCgJpZBgBIAEoCRIRCgllbGltaW5hZG8YAiABKAgSHAoUdWx0aW1hX2FjdHVhbGl6YWNpb24YAyABKAMSDQoFZmVjaGEYBCABKAkSOwoHaW5kaWNlcxgFIAMoCzIqLnNleHRhbnRlLnNhdGVsaXRlLnYxLkVzY2VuYUluZGljZVRpbGVJdGVtEh4KEWNsb3Vkc19wZXJjZW50YWdlGAYgASgBSACIAQESHwoSc2hhZG93c19wZXJjZW50YWdlGAcgASgBSAGIAQESHgoRdG90YWxfdXNlZnVsX2FyZWEYCCABKAFIAogBARIiChV0b3RhbF9ub3RfdXNlZnVsX2FyZWEYCSABKAFIA4gBAUIUChJfY2xvdWRzX3BlcmNlbnRhZ2VCFQoTX3NoYWRvd3NfcGVyY2VudGFnZUIUChJfdG90YWxfdXNlZnVsX2FyZWFCGAoWX3RvdGFsX25vdF91c2VmdWxfYXJlYSJOChtMaXN0RXNjZW5hc0J5RmluY2FJZFJlcXVlc3QSEAoIZmluY2FfaWQYASABKAkSHQoVdWx0aW1hX3NpbmNyb25pemFjaW9uGAIgASgDInEKHExpc3RFc2NlbmFzQnlGaW5jYUlkUmVzcG9uc2USLwoFaXRlbXMYASADKAsyIC5zZXh0YW50ZS5zYXRlbGl0ZS52MS5Fc2NlbmFJdGVtEiAKGHRpbWVzdGFtcF9zaW5jcm9uaXphY2lvbhgCIAEoAyKdAQoTRXN0YWRpc3RpY2FMb3RlSXRlbRIKCgJpZBgBIAEoCRIRCgllbGltaW5hZG8YAiABKAgSHAoUdWx0aW1hX2FjdHVhbGl6YWNpb24YAyABKAMSDQoFZmVjaGEYBCABKAkSEQoJaW5kaWNlX2lkGAUgASgJEgoKAnExGAYgASgBEgoKAnEzGAcgASgBEg8KB2F2ZXJhZ2UYCCABKAEiUQofTGlzdEVzdGFkaXN0aWNhc0J5TG90ZUlkUmVxdWVzdBIPCgdsb3RlX2lkGAEgASgJEh0KFXVsdGltYV9zaW5jcm9uaXphY2lvbhgCIAEoAyJ+CiBMaXN0RXN0YWRpc3RpY2FzQnlMb3RlSWRSZXNwb25zZRI4CgVpdGVtcxgBIAMoCzIpLnNleHRhbnRlLnNhdGVsaXRlLnYxLkVzdGFkaXN0aWNhTG90ZUl0ZW0SIAoYdGltZXN0YW1wX3NpbmNyb25pemFjaW9uGAIgASgDMpwCCg9TYXRlbGl0ZVNlcnZpY2USfQoUTGlzdEVzY2VuYXNCeUZpbmNhSWQSMS5zZXh0YW50ZS5zYXRlbGl0ZS52MS5MaXN0RXNjZW5hc0J5RmluY2FJZFJlcXVlc3QaMi5zZXh0YW50ZS5zYXRlbGl0ZS52MS5MaXN0RXNjZW5hc0J5RmluY2FJZFJlc3BvbnNlEokBChhMaXN0RXN0YWRpc3RpY2FzQnlMb3RlSWQSNS5zZXh0YW50ZS5zYXRlbGl0ZS52MS5MaXN0RXN0YWRpc3RpY2FzQnlMb3RlSWRSZXF1ZXN0GjYuc2V4dGFudGUuc2F0ZWxpdGUudjEuTGlzdEVzdGFkaXN0aWNhc0J5TG90ZUlkUmVzcG9uc2VCC6oCCEFwaS5HcnBjYgZwcm90bzM");

/**
 * Imagen de un indice dentro de una escena.
 *
 * @generated from message sextante.satelite.v1.EscenaIndiceTileItem
 */
export type EscenaIndiceTileItem = Message<"sextante.satelite.v1.EscenaIndiceTileItem"> & {
  /**
   * @generated from field: string indice_id = 1;
   */
  indiceId: string;

  /**
   * URL de la imagen del indice para dibujarla en el mapa.
   *
   * @generated from field: string image_uri = 2;
   */
  imageUri: string;
};

/**
 * Describes the message sextante.satelite.v1.EscenaIndiceTileItem.
 * Use `create(EscenaIndiceTileItemSchema)` to create a new message.
 */
export const EscenaIndiceTileItemSchema: GenMessage<EscenaIndiceTileItem> = /*@__PURE__*/
  messageDesc(file_satelite, 0);

/**
 * Escena satelital de una finca en una fecha, con una imagen por indice.
 *
 * @generated from message sextante.satelite.v1.EscenaItem
 */
export type EscenaItem = Message<"sextante.satelite.v1.EscenaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * ISO 8601 (DateTime, no DateOnly)
   *
   * @generated from field: string fecha = 4;
   */
  fecha: string;

  /**
   * @generated from field: repeated sextante.satelite.v1.EscenaIndiceTileItem indices = 5;
   */
  indices: EscenaIndiceTileItem[];

  /**
   * Nubosidad de la escena, en porcentaje. Ausente hasta que el worker la calcule. La app la usa para decidir
   * si la escena se puede mostrar.
   *
   * @generated from field: optional double clouds_percentage = 6;
   */
  cloudsPercentage?: number | undefined;

  /**
   * Sombras de nubes en la escena, en porcentaje. Mismo uso que clouds_percentage.
   *
   * @generated from field: optional double shadows_percentage = 7;
   */
  shadowsPercentage?: number | undefined;

  /**
   * @generated from field: optional double total_useful_area = 8;
   */
  totalUsefulArea?: number | undefined;

  /**
   * @generated from field: optional double total_not_useful_area = 9;
   */
  totalNotUsefulArea?: number | undefined;
};

/**
 * Describes the message sextante.satelite.v1.EscenaItem.
 * Use `create(EscenaItemSchema)` to create a new message.
 */
export const EscenaItemSchema: GenMessage<EscenaItem> = /*@__PURE__*/
  messageDesc(file_satelite, 1);

/**
 * Pedido de las escenas de una finca.
 *
 * @generated from message sextante.satelite.v1.ListEscenasByFincaIdRequest
 */
export type ListEscenasByFincaIdRequest = Message<"sextante.satelite.v1.ListEscenasByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.satelite.v1.ListEscenasByFincaIdRequest.
 * Use `create(ListEscenasByFincaIdRequestSchema)` to create a new message.
 */
export const ListEscenasByFincaIdRequestSchema: GenMessage<ListEscenasByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_satelite, 2);

/**
 * Escenas que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.satelite.v1.ListEscenasByFincaIdResponse
 */
export type ListEscenasByFincaIdResponse = Message<"sextante.satelite.v1.ListEscenasByFincaIdResponse"> & {
  /**
   * @generated from field: repeated sextante.satelite.v1.EscenaItem items = 1;
   */
  items: EscenaItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.satelite.v1.ListEscenasByFincaIdResponse.
 * Use `create(ListEscenasByFincaIdResponseSchema)` to create a new message.
 */
export const ListEscenasByFincaIdResponseSchema: GenMessage<ListEscenasByFincaIdResponse> = /*@__PURE__*/
  messageDesc(file_satelite, 3);

/**
 * Estadistica de un indice en un lote para la fecha de una escena.
 *
 * @generated from message sextante.satelite.v1.EstadisticaLoteItem
 */
export type EstadisticaLoteItem = Message<"sextante.satelite.v1.EstadisticaLoteItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * @generated from field: string fecha = 4;
   */
  fecha: string;

  /**
   * @generated from field: string indice_id = 5;
   */
  indiceId: string;

  /**
   * Primer cuartil de los valores del indice en el lote.
   *
   * @generated from field: double q1 = 6;
   */
  q1: number;

  /**
   * Tercer cuartil de los valores del indice en el lote.
   *
   * @generated from field: double q3 = 7;
   */
  q3: number;

  /**
   * Promedio de los valores del indice en el lote.
   *
   * @generated from field: double average = 8;
   */
  average: number;
};

/**
 * Describes the message sextante.satelite.v1.EstadisticaLoteItem.
 * Use `create(EstadisticaLoteItemSchema)` to create a new message.
 */
export const EstadisticaLoteItemSchema: GenMessage<EstadisticaLoteItem> = /*@__PURE__*/
  messageDesc(file_satelite, 4);

/**
 * Pedido de las estadisticas de un lote.
 *
 * @generated from message sextante.satelite.v1.ListEstadisticasByLoteIdRequest
 */
export type ListEstadisticasByLoteIdRequest = Message<"sextante.satelite.v1.ListEstadisticasByLoteIdRequest"> & {
  /**
   * @generated from field: string lote_id = 1;
   */
  loteId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.satelite.v1.ListEstadisticasByLoteIdRequest.
 * Use `create(ListEstadisticasByLoteIdRequestSchema)` to create a new message.
 */
export const ListEstadisticasByLoteIdRequestSchema: GenMessage<ListEstadisticasByLoteIdRequest> = /*@__PURE__*/
  messageDesc(file_satelite, 5);

/**
 * Estadisticas que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.satelite.v1.ListEstadisticasByLoteIdResponse
 */
export type ListEstadisticasByLoteIdResponse = Message<"sextante.satelite.v1.ListEstadisticasByLoteIdResponse"> & {
  /**
   * @generated from field: repeated sextante.satelite.v1.EstadisticaLoteItem items = 1;
   */
  items: EstadisticaLoteItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.satelite.v1.ListEstadisticasByLoteIdResponse.
 * Use `create(ListEstadisticasByLoteIdResponseSchema)` to create a new message.
 */
export const ListEstadisticasByLoteIdResponseSchema: GenMessage<ListEstadisticasByLoteIdResponse> = /*@__PURE__*/
  messageDesc(file_satelite, 6);

/**
 * Escenas y estadisticas satelitales de la SPA Cliente. Logica propia del servicio gRPC, sin la capa vieja
 * de servicios. Ambos son de **solo consulta**
 * -todo lo escribe SateliteWorkerService, no hay guardado/borrado desde Cliente- asi que este
 * servicio solo tiene 2 rpc de listado, cada uno con su propio delta real (no son catalogos).
 * Requiere sesion de la app Cliente.
 * 
 * Nombres de mensaje con prefijo de dominio: ver terceros_lote.proto para el gotcha real del
 * csharp_namespace compartido — revisar que un nombre no exista ya en otro .proto antes de usarlo.
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.satelite.v1.SateliteService
 */
export const SateliteService: GenService<{
  /**
   * Escenas satelitales de una finca, por delta.
   *
   * @generated from rpc sextante.satelite.v1.SateliteService.ListEscenasByFincaId
   */
  listEscenasByFincaId: {
    methodKind: "unary";
    input: typeof ListEscenasByFincaIdRequestSchema;
    output: typeof ListEscenasByFincaIdResponseSchema;
  },
  /**
   * Estadisticas de los indices en un lote, por delta. Alimentan el grafico de tendencia.
   *
   * @generated from rpc sextante.satelite.v1.SateliteService.ListEstadisticasByLoteId
   */
  listEstadisticasByLoteId: {
    methodKind: "unary";
    input: typeof ListEstadisticasByLoteIdRequestSchema;
    output: typeof ListEstadisticasByLoteIdResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_satelite, 0);

